module.exports = __webpack_public_path__ + "static/media/IMG_8025.04371c23.jpg";